<template>
    <div>
        <a class="banner" href="https://sass.api.shoujimama.cn/rent/download" target="_blank">
            <img :src="imageUrl + '/a75d18d7-ddec-8a7d-2249-54fb6d15020a.png'" />
            <!-- <div class="banner-content">
                <a href="https://sass.api.shoujimama.cn/rent/download" target="_blank" class="banner-btn">下载APP</a>
            </div> -->
        </a>
        <div class="join-box">
            <div class="module-title">招商加盟</div>
            <div class="module-subtitle">加入我们，共享蓝图</div>
            <div class="join-title">让我们一起合作做一个了不起的项目吧！</div>
            <div class="join-content">
                <div class="join-img">
                    <img :src="imageUrl + '/28d9148a-2798-e112-40ad-b6f1a464957a.png'" />
                </div>
                <div class="join-form">
                    <el-form :model="formData" ref="formData">
                        <el-form-item prop="name">
                            <el-input type="text" v-model="formData.name" placeholder="请输入联系人姓名"></el-input>
                        </el-form-item>
                        <el-form-item prop="mobile">
                            <el-input type="text" v-model="formData.mobile" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item prop="mode" style="margin-bottom: 10px;">
                            <el-select class="select-box" v-model="formData.mode" placeholder="请选择您的项目类型">
                                <el-option value="1" label="商家入驻垫资自营"></el-option>
                                <el-option value="2" label="平台垫资"></el-option>
                                <el-option value="3" label="第三方入驻垫资平台代运营"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="mode-box">
                            <div v-if="formData.mode == 1">说明：手机和配件利润归商家所有，i商家给平台2%的费用。</div>
                            <div v-if="formData.mode == 2">说明：手机和配件利润都归平台所有，平台给商家2%的费用。</div>
                            <div v-if="formData.mode == 3">说明：面向全行业招纳，加盟商只需要出资金，由平台代运营，平台保证一定金额的保本年化收益。</div>
                        </div>
                        <el-form-item>
                            <el-input type="textarea" v-model="content" placeholder="请描述您的问题"></el-input>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button @click="submit" :loading="btnLoad">提交申请</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                btnLoad: false,
                content: '',
                formData: {
                    name: '',
                    mobile: '',
                    mode: '',
                    city: '未知'
                },
                rules: {
                    name: [{
                        required: true,
                        message: '请输入联系人姓名',
                        trigger: 'blur'
                    }, ],
                    mobile: [{
                        required: true,
                        message: '请输入联系人手机号',
                        trigger: 'blur'
                    }, ],
                    mode: [{
                        required: true,
                        message: '请选择项目类型',
                        trigger: 'change'
                    }]
                }
            };
        },
        created() {

        },
        mounted() {},
        methods: {
            submit() {
                this.btnLoad = true;
                if (this.formData.name == '') {
                    this.$message({
                        message: '请输入联系人姓名',
                        type: 'warning'
                    });
                    this.btnLoad = false;
                    return;
                }
                if (this.formData.mobile == '') {
                    this.$message({
                        message: '请输入联系人手机号',
                        type: 'warning'
                    });
                    this.btnLoad = false;
                    return;
                }
                if (this.formData.mode == '') {
                    this.$message({
                        message: '请选择项目模式',
                        type: 'warning'
                    });
                    this.btnLoad = false;
                    return;
                }

                let url = `investmentRecord/apply`
                this.$http.post(url, this.formData)
                    .then((res) => {
                        console.log(res.data);
                        if (res.data.status == 1) {
                            this.$message({
                                message: res.data.msg,
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: 'warning'
                            });
                        }
                        this.btnLoad = false;
                    })
                    .catch((err) => {
                        this.btnLoad = false;
                        this.$message({
                            message: res.data.msg,
                            type: 'warning'
                        });
                        console.log(err) //错误信息
                    })
            },
        }
    };
</script>
<style lang="scss" scoped>
    .module-title {
        font-size: 34px;
        font-weight: bold;
        color: #121212;
        text-align: left;
    }

    .module-subtitle {
        font-size: 20px;
        color: #999999;
        margin-top: 16px;
        text-align: left;
    }

    .join-box {
        padding: 50px 60px;

        .join-title {
            color: #121212;
            font-size: 26px;
            margin-top: 50px;
        }

        .join-content {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 50px;

            .join-img {
                width: 290px;
                height: 450px;

                img {
                    width: 100%;
                }
            }

            .join-form {
                width: 310px;

                .mode-box {
                    font-size: 14px;
                    color: #1966FF;

                    p {
                        margin-top: 0 !important;
                    }
                }

                .el-form-item {
                    margin-top: 20px;

                    ::v-deep .el-input__inner,
                    ::v-deep .el-textarea__inner {
                        height: 56px;
                        line-height: 56px;
                        padding: 0px 30px;
                        border: none;
                        background-color: #F5F5F5 !important;
                        font-size: 20px;
                        border-radius: 4px;
                        color: #121212;
                    }

                    ::v-deep .el-textarea__inner {
                        height: 124px;
                    }

                    ::v-deep .el-input__inner::placeholder,
                    ::v-deep .el-textarea__inner::placeholder {
                        color: #808080;
                    }

                    .el-select {
                        width: 100%;
                    }
                }

                .el-form-item:first-child {
                    margin-top: 0px;
                }

                .el-button {
                    background-color: #1966FF;
                    width: 100%;
                    color: #ffffff;
                    border-radius: 6px;
                    height: 70px;
                    font-size: 20px;
                    font-weight: 800;
                }

            }
        }
    }
</style>